import CloseMiniIcon from '@/assets/close-mini.svg?react'
import { Loader } from '@mantine/core'
import { useHover } from '@mantine/hooks'
import { IconReload } from '@tabler/icons-react'
import clsx from 'clsx'
import { AnimatePresence, motion, type HTMLMotionProps } from 'motion/react'
import { type PropsWithChildren } from 'react'
import styles from './Attachment.module.css'

export interface AttachmentProps extends PropsWithChildren<HTMLMotionProps<'div'>> {
	isLoading?: boolean
	onClose?: () => void
	onRetry?: () => void
	isFailed?: boolean
}

export default function Attachment({
	isLoading = false,
	onClose,
	onRetry,
	children,
	isFailed = false,
	className,
	...props
}: AttachmentProps) {
	const { ref, hovered } = useHover()
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			className={clsx(styles.root, className)}
			ref={ref}
			{...props}
		>
			<div className={`content ${styles.content}`}>
				{children}
				<AnimatePresence>
					{isLoading && (
						<motion.div
							key="loading"
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							className={styles.loading}
						>
							<Loader className={styles.loader} />
						</motion.div>
					)}
					{isFailed && (
						<motion.div
							key="failed"
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							className={styles.failed}
							role="button"
							aria-label="重试加载"
							title="重试加载"
							onClick={(e) => {
								e.stopPropagation()
								onRetry?.()
							}}
						>
							<IconReload className={styles.reloadIcon} />
						</motion.div>
					)}
					{hovered && (
						<motion.div
							key="close"
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							className={styles.closeButton}
							role="button"
							aria-label="移除附件"
							title="移除附件"
							onClick={(e) => {
								e.stopPropagation()
								onClose?.()
							}}
						>
							<CloseMiniIcon className={styles.closeIcon} />
						</motion.div>
					)}
				</AnimatePresence>
			</div>
		</motion.div>
	)
}
